export default "__VITE_ASSET__Pe$_$VHX__"